import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../../Components/profilebody/profilebody.module.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { addAccountUserThunk } from '../../../../Website/redux/AccountUserSlice';
import { useNavigate } from 'react-router-dom';

const AddNewUserComp = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const {loading} = useSelector((state)=>state.accountUser)
    const togglePasswordVisibility = () => setShowPassword((prev) => !prev);
    const toggleConfirmPasswordVisibility = () => setShowConfirmPassword((prev) => !prev);

    const validationSchema = Yup.object({
        fullName: Yup.string().required('Full name is required'),
        phone: Yup.string()
            .matches(/^\d+$/, 'Phone number must be numeric')
            .required('Phone number is required'),
        email: Yup.string().email('Invalid email format').required('Email is required'),
        password: Yup.string()
            .min(6, 'Password must be at least 6 characters')
            .required('Password is required'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password')], 'Passwords must match')
            .required('Confirm password is required'),
    });

    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        resetForm,
        setFieldValue,
        isSubmitting
    } = useFormik({
        initialValues: {
            fullName: '',
            phone: '',
            email: '',
            password: '',
            confirmPassword: '',
        },
        validationSchema,
        onSubmit: async(values) => {
            console.log('Form values:', values);
            const status =await dispatch(addAccountUserThunk(values))
            if(status.payload === 200){
                navigate(-1)
            }
        },
    });

    return (
        <div className={styles.profilebodyContainer}>
            <div className={styles.profileheader}>
                <h2>Add new user</h2>
                <button className={styles.editbtn} onClick={()=>navigate(-1)}>Back to List</button>

            </div>

            <form className={styles.profilebodyContent} onSubmit={handleSubmit}>
                <div className={styles.profilebodyDetails} style={{ width: '100%' }}>
                    <div style={{ display: 'flex', gap: '14px' }}>
                        <label className={styles.addCatLabel} style={{ width: '50%' }}>
                            Full name
                            <div className={styles.logininputContainer}>
                                <input
                                    type="text"
                                    id="fullName"
                                    name="fullName"
                                    value={values.fullName}
                                    placeholder='Enter'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </div>
                            {errors.fullName && touched.fullName && (
                                <div className={styles.error}>{errors.fullName}</div>
                            )}
                        </label>
                        <label className={styles.addCatLabel} style={{ width: '50%' }}>
                            Phone number
                            <div className={styles.logininputContainer}>
                                <input
                                    type="text"
                                    id="phone"
                                    name="phone"
                                     placeholder='Enter'
                                    value={values.phone}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </div>
                            {errors.phone && touched.phone && (
                                <div className={styles.error}>{errors.phone}</div>
                            )}
                        </label>
                    </div>
                    <div style={{ display: 'flex', gap: '14px' }}>
                        <label className={styles.addCatLabel} style={{ width: '49.2%' }}>
                            Email id
                            <div className={styles.logininputContainer}>
                                <input
                                    type="text"
                                    id="email"
                                    name="email"
                                     placeholder='Enter'
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </div>
                            {errors.email && touched.email && (
                                <div className={styles.error}>{errors.email}</div>
                            )}
                        </label>
                    </div>
                    <div style={{ display: 'flex', gap: '14px' }}>
                        <label className={styles.addCatLabel} style={{ width: '50%' }}>
                            New Password
                            <div className={styles.logininputContainer}>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    id="password"
                                    name="password"
                                    value={values.password}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="********"
                                /*  className={styles.addCatInput} */
                                />
                                <FontAwesomeIcon
                                    icon={showPassword ? faEyeSlash : faEye}
                                    className={styles.loginpasswordIcon}
                                    onClick={togglePasswordVisibility}
                                />

                            </div>
                            {errors.password && touched.password && (
                                <div className={styles.error}>{errors.password}</div>
                            )}
                        </label>
                        <label className={styles.addCatLabel} style={{ width: '50%' }}>
                            Confirm Password
                            <div className={styles.logininputContainer}>
                                <input
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    value={values.confirmPassword}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="********"
                                />
                                <FontAwesomeIcon
                                    icon={showConfirmPassword ? faEyeSlash : faEye}
                                    className={styles.loginpasswordIcon}
                                    onClick={toggleConfirmPasswordVisibility}
                                />
                            </div>
                            {errors.confirmPassword && touched.confirmPassword && (
                                <div className={styles.error}>
                                    {errors.confirmPassword}
                                </div>
                            )}
                        </label>
                    </div>
                    <div className={styles.mainBtns} style={{marginTop:15}}>
                        <button className={styles.addBtn} type='submit' disabled={loading}>{loading ? 'please wait...' : 'Save user'}</button>
                        <button className={styles.quoteBtn}  onClick={resetForm}>Cancel</button>
                    </div>

                </div>
            </form>
        </div>
    )
}

export default AddNewUserComp